<template>
  <base-widget
    icon="currency-dollar"
    :loading="isLoading"
    :title="$t('claim.expenses')"
  >
    <oxd-bar-chart
      :grid="false"
      :data="dataset"
      :y-axsis="false"
      :aspect-ratio="false"
      wrapper-classes="emp-attendance-chart"
    ></oxd-bar-chart>
    <oxd-divider />
    <div class="orangehrm-attendance-card-summary">
      <div class="orangehrm-attendance-card-summary-week">
        <oxd-text tag="p"> Total Expenses: {{ totalExpenses }} </oxd-text>
      </div>
    </div>
    <oxd-pie-chart
      :data="piedataset"
      :aspect-ratio="false"
      :custom-legend="true"
      :custom-tooltip="true"
      wrapper-classes="emp-attendance-chart"
    ></oxd-pie-chart>
  </base-widget>
</template>
<script>
import {navigate} from '@/core/util/helper/navigation';
import useLocale from '@/core/util/composable/useLocale';
import {APIService} from '@/core/util/services/api.service';
import BaseWidget from '@/orangehrmDashboardPlugin/components/BaseWidget.vue';
import {OxdBarChart, OxdPieChart, OxdIcon, CHART_COLORS} from '@ohrm/oxd';

export default {
  name: 'ExpenseWidget',

  components: {
    'base-widget': BaseWidget,
    'oxd-bar-chart': OxdBarChart,
    'oxd-pie-chart': OxdPieChart,
  },

  setup() {
    const {locale} = useLocale();
    const httpex = new APIService(
      window.appGlobal.baseUrl,
      'api/v2/pim/expenses',
    );
    const httpextypes = new APIService(
      window.appGlobal.baseUrl,
      'api/v2/pim/expenses/types',
    );

    return {
      httpex,
      httpextypes,
      locale,
    };
  },

  data() {
    return {
      dataset: [],
      piedataset: [],
      expenseTypes: [],
      isLoading: false,
      totalExpenses: 0,
    };
  },

  async beforeMount() {
    await this.fetchExpenseTypes();
    this.fetchWidgetData();
  },
  methods: {
    getNameById(id) {
      for (let i = 0; i < this.expenseTypes.length; i++) {
        if (this.expenseTypes[i].id == Number(id)) {
          return this.expenseTypes[i].name;
        }
      }
      return 'Type not found';
    },
    fetchWidgetData() {
      this.isLoading = true;
      this.httpex
        .getAll({})
        .then((response) => {
          const {data, meta} = response.data;
          const {total, totalAmount} = meta;

          const colors = [
            CHART_COLORS.COLOR_HEAT_WAVE,
            CHART_COLORS.COLOR_CHROME_YELLOW,
            CHART_COLORS.COLOR_YELLOW_GREEN,
            CHART_COLORS.COLOR_MOUNTAIN_MEADOW,
            CHART_COLORS.COLOR_PACIFIC_BLUE,
            CHART_COLORS.COLOR_BLEU_DE_FRANCE,
            CHART_COLORS.COLOR_MAJORELLE_BLUE,
            CHART_COLORS.COLOR_MEDIUM_ORCHID,
            CHART_COLORS.COLOR_FANDANGO_PINK,
          ];

          // Group the amounts by types
          const amountsByType = data.reduce((acc, item) => {
            const typeId = this.getNameById(item.expenseType.id);
            acc[typeId] = (acc[typeId] || 0) + item.amount;
            return acc;
          }, {});

          // Prepare data for the pie chart
          const pielabels = Object.keys(amountsByType); // Type IDs
          const amounts = Object.values(amountsByType); // Corresponding amounts

          // Update the dataset
          this.piedataset = pielabels.map((type, index) => ({
            label: type,
            value: amounts[index],
            color: colors[index],
          }));

          // Group data by month
          const monthlyData = data.reduce((acc, expense) => {
            const month = new Date(expense.date.date).toISOString().slice(0, 7); // Get year-month
            acc[month] = (acc[month] || 0) + expense.amount;
            return acc;
          }, {});

          const sortedMonthlyData = Object.entries(monthlyData)
            .sort(([monthA], [monthB]) => new Date(monthA) - new Date(monthB)) // Sort by date
            .reduce((acc, [month, amount]) => {
              acc[month] = amount;
              return acc;
            }, {});

          // Prepare data for the chart
          const labels = Object.keys(sortedMonthlyData);
          const chartData = Object.values(sortedMonthlyData);
          this.totalExpenses = totalAmount.toFixed(2);
          // Update the dataset
          this.dataset = labels.map((month, index) => ({
            label: month,
            value: chartData[index],
            color: colors[index], //CHART_COLORS.COLOR_HEAT_WAVE, // Use a predefined color or customize as needed
          }));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    fetchExpenseTypes() {
      this.isLoading = true;
      this.httpextypes
        .getAll({})
        .then((response) => {
          const {data, meta} = response.data;
          this.expenseTypes = data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
<style src="./employee-attendance-widget.scss" lang="scss" scoped></style>
